module.exports = __webpack_public_path__ + "static/media/chevron-left.10c2e675.svg";